import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.expressedInterest;

const getExpressedInterest = createSelector(
  getData,
  expressedInterest => expressedInterest
);

export default getExpressedInterest;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getExpressedInterest.js